export const CONFIG = {
  "PROJECTNAME": "demka",
  "COMPANYNAME": "Demka",
  "DFTLNGCODE": "de",
  "URL": "https://api.fbsshop.de",
  "PAYMENTSERVER": "https://stripe.mobiapi.de",
  "VENDORID": "10001120",
  "IMAGEURL": "/images",
  "PAYMENTSYSTEM": false,
  "BANNER": false,
  "BRANDS": false,
  "FLAG_ITEM_ON_HAND": false,
  "MENU_LOGO_BACKGROUND": false,
  "LOGO_LOGIN_BACKGROUND": true,
  "MENU_WHITE_BACKGROUND": false,
  "colors": {
    "primary": "#007eb4",
    "primary100": "#ccebf9",
    "light": "#007eb4",
    "secondary": "#007eb4",
    "dark": "#009EE2",
    "siteColor3": "#fff",
    "menuSecondary": "#007eb4"
  }
};